import React from "react";

export default function PdfSplitMerge() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Split and merge PDFs (simple demo)</h2>
      <p>This tool will be implemented here. File conversion logic will run in the browser.</p>
    </div>
  );
}
